import React from 'react';
import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';
import StudyNotificationCard, {
  StudyNotificationCardProps
} from './StudyNotificationCard';

const ITEM_WIDTH = 158;
const ITEM_MARGIN = 16;

const StyledContainer = styled.View`
  width: 100%;
`;

const StyledTouchable = styled.TouchableOpacity`
  ${Platform.OS === 'web' ? 'margin-bottom: 6px' : ''}
`;

const StyledSeparator = styled.View`
  width: ${ITEM_MARGIN}px;
`;

interface StudyNotificationListProps {
  data: Array<StudyNotificationCardProps>;
  onSelect?: (notification: StudyNotificationCardProps) => void;
}

const StudyNotificationList: React.FC<StudyNotificationListProps> = ({
  data,
  onSelect
}) => {
  const getItemLayout = (_data: any, index: number) => {
    return {
      length: ITEM_WIDTH + ITEM_MARGIN,
      offset: (ITEM_WIDTH + ITEM_MARGIN) * index,
      index
    };
  };
  const sampleImages = [
    require('../assets/sample/study-notifications/sample-study-notification-image-1.png'),
    require('../assets/sample/study-notifications/sample-study-notification-image-2.png'),
    require('../assets/sample/study-notifications/sample-study-notification-image-3.png'),
    require('../assets/sample/study-notifications/sample-study-notification-image-4.png')
  ];
  return (
    <StyledContainer>
      <FlatList
        keyExtractor={(_, index) => index.toString()}
        horizontal
        overScrollMode='never'
        showsHorizontalScrollIndicator={Platform.OS === 'web'}
        data={data}
        getItemLayout={getItemLayout}
        initialNumToRender={10}
        maxToRenderPerBatch={10}
        ItemSeparatorComponent={() => <StyledSeparator />}
        renderItem={listItem => {
          const item = listItem.item;
          return (
            <StyledTouchable
              onPress={() => {
                onSelect?.(item);
              }}
            >
              <StudyNotificationCard
                title={item.title}
                description={item.description}
                image={sampleImages[listItem.index % sampleImages.length]}
              />
            </StyledTouchable>
          );
        }}
      />
    </StyledContainer>
  );
};

export default StudyNotificationList;
